import React, { Fragment } from 'react';

// import cn from 'classnames';
import PropTypes from 'prop-types';
import { each, isEmpty } from 'lodash';
import { AiOutlineSearch } from 'react-icons/ai';
import { CgSpinner } from 'react-icons/cg';
import cn from 'classnames';
import { Menu, Transition } from '@headlessui/react';

import { Badge } from 'modules/common';

import { useGetCategoryList } from '../../ds-category-picker/hooks';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import CategoryList from '../../ds-category-picker/components/CategoryList';

function FormCategoryInput({ name, onChange, value, containerClassName }) {
  const [filter] = React.useState({
    keyword: '',
    level: [2, 3],
  });
  const [isApiLoading, categoryOptions] = useGetCategoryList(filter);

  const [label, setLabel] = React.useState(value?.label || '');

  const [showOptions, setShowOptions] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const myRef = React.useRef();
  useOnClickOutside(myRef, setShowOptions);
  const [, setOptions] = React.useState([]);

  const handleToggle = (v) => {
    const items = [];
    each(v, (r1) => {
      each(r1?.level3 || [], (r2) => {
        items.push(r2?.value);
      });
    });
    onChange((state) => ({
      ...state,
      [name]: items,
    }));
  };

  const [formattedValue, flat] = React.useMemo(() => {
    const filtered = categoryOptions.filter((x) => {
      const isSelected =
        (x.child || []).findIndex((y) => (value || []).indexOf(y.value) > -1) >
        -1;
      return isSelected;
    });
    const tempFlat = {};
    const newData = filtered.map((row) => {
      const level3 = (row?.child || []).filter(
        (x) => (value || []).indexOf(x.value) > -1
      );
      each(level3, (v) => {
        tempFlat[v?.value] = v;
      });
      return {
        level2: {
          label: row?.label,
          value: row?.value,
        },
        level3,
      };
    });
    return [newData, tempFlat];
  }, [categoryOptions, value]);

  const handleRemoveItem = (row) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    onChange((state) => ({
      ...state,
      [name]: (state[name] || []).filter((x) => x !== row?.value),
    }));
  };

  const handleFocus = () => {
    if (isEmpty(label)) {
      setIsLoading(true);
      // eslint-disable-next-line
      console.log('load options');
      setOptions([]);
      setIsLoading(false);
    }

    setShowOptions(!showOptions);
  };

  const handleClear = () => {
    setShowOptions(false);
    setLabel('');
    onChange((state) => ({
      ...state,
      [name]: [],
    }));
  };
  return (
    <div ref={myRef} className="relative">
      <div className="relative rounded-md shadow-sm">
        <div
          className={cn(
            'form-input p-[9px] flex flex-wrap gap-2 cursor-pointer',
            containerClassName
          )}
          onClick={handleFocus}
          aria-hidden="true"
        >
          <div className="form-icon">
            {isLoading ? (
              <CgSpinner className="h-5 w-5 animate-spin" />
            ) : (
              <AiOutlineSearch className="h-4 w-4" />
            )}
          </div>

          {(value || []).length < 1 ? (
            <div className="text-gray-400">Add Category...</div>
          ) : (
            (value || [])?.map((item, key) => {
              const row = flat[item];

              return (
                <Badge
                  // eslint-disable-next-line react/no-array-index-key
                  key={key}
                  label={row?.label}
                  onClose={handleRemoveItem(row)}
                />
              );
            })
          )}
        </div>

        {value?.value ? (
          <button
            className="absolute top-0 right-0 py-2 px-3 font-semibold text-primary-500 hover:underline"
            type="button"
            onClick={handleClear}
          >
            Clear
          </button>
        ) : null}
      </div>
      <Menu>
        {() => (
          <>
            <Transition
              show={showOptions}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Menu.Items
                className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                static
              >
                {categoryOptions.length < 1 ? (
                  <div className="block cursor-default select-none relative py-1 pl-3 pr-9 text-center text-gray-400">
                    {isApiLoading ? 'Loading...' : 'No items.'}
                  </div>
                ) : (
                  <div>
                    <CategoryList
                      key={value?.length} // FIXME: toggle reset bug
                      data={categoryOptions}
                      value={formattedValue}
                      level={filter?.level || []}
                      onGetValue={handleToggle}
                      isInput
                    />
                  </div>
                )}
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  );
}

FormCategoryInput.defaultProps = {
  containerClassName: '',
};

FormCategoryInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
  value: PropTypes.instanceOf(Array).isRequired,
};

export default FormCategoryInput;
